import { Icon, I } from '@/components/icons';

/** 共用清單搜尋框(即時過濾,可清除)。 */
export function SearchInput({
  value,
  onChange,
  placeholder = '搜尋…',
  width = 240,
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  width?: number | string;
}) {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '6px 10px',
        background: 'var(--surface)',
        border: '1px solid var(--line)',
        borderRadius: 8,
        width,
        color: 'var(--ink-3)',
      }}
    >
      <Icon d={I.search} size={14} />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{ flex: 1, border: 0, background: 'transparent', outline: 'none', fontSize: 12.5, color: 'var(--ink)', minWidth: 0 }}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="清除"
          style={{ border: 0, background: 'transparent', cursor: 'pointer', color: 'var(--ink-4)', fontSize: 14, lineHeight: 1 }}
        >
          ×
        </button>
      )}
    </div>
  );
}

/** 不分大小寫的子字串比對工具。 */
export const matches = (haystack: string, q: string) =>
  haystack.toLowerCase().includes(q.trim().toLowerCase());
